import API from '@/constant/API';
import { DEDUCT_TYPE } from '@/constant/Constant';
import axiosInstance from '@/utils/axios';
import moment from 'moment';
import React, {useEffect, useMemo, useState} from 'react';
import { useTranslation } from 'react-i18next';

import {Stack, Typography, useTheme, tableCellClasses, styled } from "@mui/material";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {TABBAR_TYPE} from "@/components/Tabbar.jsx";
import {LoadingButton} from "@mui/lab";

export default function useTransAuthRules() {
  const { t } = useTranslation();
  const [ruleType, setRuleType] = useState();

  const [cardId, setCardId] = useState();
  const [authRule, setAuthRule] = useState(null);

  const [declineRule, setDeclineRule] = useState(null);
  const [smallAuthRule, setSmallAuthRule] = useState(null);

  useEffect(() => {
    if (cardId) {
      _initRules();
    }
  }, [cardId]);

  const _getYearMonth = () => {
    return moment().format('YYYY-MM');
  }

  const _initRules = async () => {
    const res = await axiosInstance.post(API.TRANS_EXEMPTION_RULE, {
      month: _getYearMonth(),
      cardId: cardId,
    });
    setAuthRule(res);

    if (res.ruleItems.length) {
      res.ruleItems.forEach(item => {
        if (item.type == 1) {
          setDeclineRule(item);
        } else {
          setSmallAuthRule(item);
        }
      })
    }
  }

  useEffect(() => {
    if (authRule) {
      console.log('authRule', authRule)
    }
  }, [authRule]);

  const renderAuthRule = () => {
    if (ruleType == DEDUCT_TYPE.DECLINE) {
      return _renderDeclineAuthRule();
    } else {
      // return _renderSmallAuthRule();
    }
  }

  const _renderDeclineAuthRule = (item) => {
    const theme = useTheme()
    const title = t('declined_transaction_fee_stats');

    const declineRuleItem = useMemo(() => {
      if (!authRule) {
        return {}
      }
      return authRule?.ruleItems.find(_ => _.type == 1)
    }, [authRule]);

    const content = <>
      <Stack>
        <Stack
        sx={{
          backgroundColor: theme.palette.background.card,
          margin: '0 16px',
          padding: '12px 16px',
        }}
        >
          <img />
          <Typography
          sx={{fontSize: '12px'}}
          ><span style={{color: theme.palette.text.secondary}} >{t('card_number')}</span> .... {item?.last4}</Typography>
          <Typography
            sx={{fontSize: '12px'}}
          >Declined transactions this month <span style={{ fontWeight: 'bold' }}>{authRule?.declinedTotalCount}</span></Typography>
          <Typography
            sx={{fontSize: '12px'}}
          >Number of failures remaining this month <span style={{fontWeight: 'bold'}}>{authRule?.declinedTotalCount}</span>/{declineRuleItem?.freeCount}</Typography>
        </Stack>
        <Stack sx={{margin: '24px 16px 24px 16px'}}>
          <Typography
          sx={{fontWeight: 'bold', fontSize: '12px'}}
          >{t('rules')}</Typography>
          <Typography
            sx={{color: theme.palette.text.secondary,  fontSize: '12px'}}
          >
            Declined transactions will increase the number of bad card records，and additional fees will be added if you exceed them. Please regulate the transaction.
          </Typography>
          <TableContainer sx={{margin: '12px 0'}}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>Item</StyledTableCell>
                  <StyledTableCell align="right">Free Count</StyledTableCell>
                  <StyledTableCell align="right">Fees</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody
              sx={{
                '& .MuiTableCell-root': {
                  fontSize: '12px'
                }
              }}
              >
                {authRule?.ruleItems.map((row) => (
                  <TableRow
                    key={row.name}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell
                      sx={{
                        width: '120px',
                        color: row.type == 0 ? theme.palette.brand.main : theme.palette.warning.main
                      }}
                      component="th" scope="row">
                      {row.name}
                    </TableCell>
                    <TableCell align="right">{row.freeCount}/{row.freeCountUnit}</TableCell>
                    <TableCell align="right">{row.fee} {row.feeUnit}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <LoadingButton fullWidth variant="contained">{t('got_it')}</LoadingButton>
        </Stack>

      </Stack>
    </>;
    return content;
  }

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    padding: '10px',
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.background.card,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  return {
    cardId,
    setCardId,
    authRule,
    declineRule,
    smallAuthRule,
    renderAuthRule,
    _renderDeclineAuthRule,
    // _renderSmallAuthRule,
    setRuleType,
  };
}
